import { PagedRequestType, PagedResultsType } from "../../../types/PagedResults";
import { get } from "../../../utils/axios-config";
import { ACADEMICYEARS } from "../../../utils/constants";
import { AcademicYearType } from "../../../types/AcademicYear";

export const getAcademicYears = async (data?: PagedRequestType) => {
    const queryParams = new URLSearchParams({
        PageNumber: data?.PageNumber?.toString() || '1',
        PageSize: data?.PageSize?.toString() || '100',
    });
    const url = `${ACADEMICYEARS}?${queryParams.toString()}`;
    return await get<PagedResultsType<AcademicYearType>>(url)
};